<template>
  <div>
    <div class="p-inputgroup template-dp">
      <Dropdown
        appendTo="self"
        :id="name"
        :name="name"
        :options="items"
        :option-label="optionLabel"
        :optionValue="optionValue"
        :placeholder="placeholder"
        v-model="inputValue"
        :option-group-label="optionGroupLabel"
        :option-group-children="optionGroupChildren"
        :class="className"
        @input="handleChange"
        @change="checkChange"
      >
        <template #value="slotProps">
          <div
            v-if="slotProps.value && resolvedCalendarOption"
            class="country-item country-item-value flex align-items-center gap-2"
          >
            <div
              class="color-box"
              :style="{
                background: resolvedCalendarOption.color
                  ? `#${resolvedCalendarOption.color}`
                  : 'transparent',
              }"
            />
            <div>{{ resolvedCalendarOption.display_name }}</div>
          </div>
          <span v-else>{{ slotProps.placeholder }}</span>
        </template>
        <template #option="slotProps">
          <div class="country-item flex align-items-center gap-2">
            <div
              class="color-box"
              :style="{ background: `#${slotProps.option.color}` }"
            />
            <div>{{ slotProps.option.display_name }}</div>
          </div>
        </template>
        <template #optiongroup="slotProps">
          <div class="flex country-item">
            <div class="width-100 calendar-template-header">
              <span> {{ slotProps.option.label }}</span>
              <span
                class="cursor flex align-items-center"
                @click="addCalendar(names[slotProps.index], slotProps.index)"
              >
                <Icon type="favicon" :icon="AppIcons.PLUS" class="Icon mx-2" />
                <span>Add</span>
              </span>
            </div>
          </div>
        </template>
      </Dropdown>
      <!-- {{ modelValue }}== {{ optionValue }}=={{ optionLabel }}=={{ inputValue }} -->
    </div>
    <small v-show="errorMessage" class="p-error block mt-1">{{ errorMessage }}</small>
  </div>
</template>
<script>
import { useField } from "vee-validate";
import { watch } from "vue";
import { Core } from "../../../../src/helpers/core";
import { getMyGemService } from "@/services";
import { mapActions } from "vuex";
import { AppIcons } from "../../../constants/app-icons";
export default {
  inject: ["service", "meta", "windowIndex"],
  props: {
    options: {
      type: [String, Array],
      default: "",
    },
    names: {
      type: [String, Array],
      default: "",
    },
    optionLabel: {
      type: String,
      default: "",
    },
    optionValue: {
      type: String,
      default: "",
    },
    optionGroupLabel: {
      type: String,
      default: "",
    },
    optionGroupChildren: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    className: {
      type: String,
      default: "",
    },
    emptyFilterMessage: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    filter: {
      type: Boolean,
      required: "",
    },
    showClear: {
      type: Boolean,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
    icon: {
      type: Boolean,
      default: true,
    },
    addon: {
      type: Boolean,
      default: true,
    },
    serviceId: {
      type: Number,
    },
    btnCreate: {
      type: Boolean,
      default: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      AppIcons,
      Core: Core,
      selectedValue: null,
      items: [],
      servicebyDomian: null,
      loading: false,
      calendars: [],
    };
  },
  computed: {
    resolvedCalendarOption() {
      const id = this.inputValue ?? this.modelValue;
      if (id == null || id === "") {
        return null;
      }
      for (const group of this.items) {
        if (group?.items?.length) {
          const nested = group.items.find((row) => row.id == id);
          if (nested) {
            return nested;
          }
        } else if (group?.id == id) {
          return group;
        }
      }
      return null;
    },
    model: {
      get() {
        return this.resolvedCalendarOption;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    color() {
      var color = "";
      this.items.forEach((element) => {
        if (element.id == this.inputValue) {
          color = element.color;
        }
      });

      return color;
    },
    CalendarName() {
      var name = "";
      this.items.forEach((element) => {
        if (element.id == this.inputValue) {
          name = element.display_name;
        }
      });

      return name;
    },
  },
  created() {
    this.servicebyDomian = getMyGemService(this.serviceId);
  },
  mounted() {
    this.emitter.on("post-saved", (event) => {
      if (event.meta.parent == this.windowIndex) {
        event.meta.cb(event);
      }
    });
    this.fetchData();
  },

  methods: {
    ...mapActions("fetch", ["fetch", "refresh"]),
    fetchData() {
      this.servicebyDomian.get().then((response) => {
        this.items = response;
        // this.names.forEach((element, index) => {
        //   this.items[index].items.forEach((element2) => {
        //     element.items.push(element2);
        //   });
        // });
      });
    },

    addCalendar(cType, index) {
      this.calendarIndex = index;
      this.emitter.emit("open-gem", {
        item: {
          key: "create",
          label: "Add a " + cType,
          service: -19,
          type: index,
          parent: this.meta.windowIndex,
          index: this.idexing,
          cb: (event) => {
            if (event.data.id) {
              this.fetchData();
            }
          },
        },
      });
    },
  },

  setup(props, { emit }) {
    const {
      value: inputValue,
      errorMessage,
      handleChange,
      meta,
      resetField,
    } = useField(props.name, undefined, {
      initialValue: String(props.modelValue),
    });
    resetField({
      value: String(props.modelValue),
    });
    watch(
      () => props.modelValue,
      (first) => {
        inputValue.value = first;
      }
    );

    function checkChange(event) {
      emit("change", event);
      inputValue.value = event.value;
      emit("update:modelValue", event.value);
      emit("changeSSR", event);
      emit("changeValue", event);
    }
    function onBtnCreate() {
      emit("btn-create");
    }

    function onBtnEdit() {
      emit("btn-edit");
    }
    return {
      handleChange,
      errorMessage,
      inputValue,
      meta,
      checkChange,
      onBtnEdit,

      onBtnCreate,
    };
  },
};
</script>
<style scoped>
div.error .dropdown {
  background-color: var(--error-bg-color);
  color: var(--error-color);
}

div.error input:focus {
  border-color: var(--error-color);
}

.Dropdown.success input {
  background-color: var(--success-bg-color);
  color: var(--success-color);
}

.Dropdown.success input:focus {
  border-color: var(--success-color);
}

.p-inputgroup {
  display: flex;
  align-items: stretch;
}
.width-72 {
  width: 72% !important;
}
.base-dropdown.p-inputgroup .inputtext,
.fluid .p-inputgroup .inputtext,
.p-inputgroup .inputwrapper,
.fluid .p-inputgroup .input {
  flex: 1 1 auto;
  width: 100% !important;
}

/* Calendar dropdown: color swatch + text same vertical center */
.template-dp :deep(.p-select-label) {
  display: flex;
  align-items: center;
}

.template-dp .country-item-value {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  line-height: normal;
}

.template-dp .country-item-value .color-box,
.template-dp .country-item .color-box {
  float: none;
  margin: 0;
  bottom: 0;
  position: static;
  flex-shrink: 0;
}
</style>
